<script>
  import { hasCapability } from '@client/stores/user';
  import { userStore } from '@client/stores/user';

  export let action;
  export let subject;

  $: hasPermission = !subject ? hasCapability(action, null, $userStore) : hasCapability(action, subject, $userStore);
</script>

{#if hasPermission}
  <slot />
{/if}
